/** Operator-facing SIP labels. Sofia ids stay cd / bitcall / voxa / wavoip / in287. */

import type { SipProfile } from "./types";

export const SIP_DISPLAY_NAMES: Record<string, string> = {
  cd: "Voxio Telecom",
  bitcall: "Bitcall",
  voxa: "Voxa SIP",
  wavoip: "Wavoip.net",
  in287: "IN287",
};

export const PROTECTED_SIP_IDS = ["cd", "bitcall"] as const;

export function isProtectedSipId(sofiaGatewayId: string): boolean {
  const id = (sofiaGatewayId || "").trim();
  return id === "cd" || id === "bitcall";
}

export function sipDisplayName(sofiaGatewayId: string, storedName?: string): string {
  const id = (sofiaGatewayId || "").trim();
  return SIP_DISPLAY_NAMES[id] || (storedName || "").trim() || id;
}

/**
 * Unwrap GET /api/admin/overview `sip` ({text,css} or string) for React children.
 * Rendering the object blanked the Admin page (React #31).
 */
export function sipStatusLabel(sip: unknown, fallback = "—"): string {
  if (typeof sip === "string") {
    const trimmed = sip.trim();
    return trimmed || fallback;
  }
  if (sip && typeof sip === "object") {
    const record = sip as Record<string, unknown>;
    for (const key of ["text", "sip_text", "sipText"]) {
      const value = record[key];
      if (typeof value === "string" && value.trim()) return value.trim();
    }
  }
  return fallback;
}

/** New call / Call setup SIP menu. Empty value = currently active trunk. */
export function sipSelectOptions(sips: SipProfile[]): Array<{ value: string; label: string }> {
  const active = sips.find((item) => item.active);
  const activeName = active ? sipDisplayName(active.sofia_gateway_id, active.name) : "";
  const activeLabel = activeName ? `Active · ${activeName}` : "Active SIP";
  return [
    { value: "", label: activeLabel },
    ...sips.map((item) => ({
      value: item.sofia_gateway_id,
      label: sipDisplayName(item.sofia_gateway_id, item.name),
    })),
  ];
}
